export default __webpack_public_path__ + "static/media/51.93411758.gif";